import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import { getNotificationsHubUrl } from "@/config/signalr";
const HUB_EVENT_NOTIFICATION_CREATED = "NotificationCreated";
/** True when the error is from our own stop() during negotiation (e.g. unmount/Strict Mode). */
function isStoppedDuringNegotiation(err) {
    const msg = err?.message ?? "";
    return msg.includes("stopped during negotiation");
}
/**
 * Connects to the notifications SignalR hub and subscribes to NotificationCreated.
 * User is associated on connect (no Join method). Use when authenticated to receive
 * real-time general notifications and show toasts.
 */
export function useNotificationsSignalR(options = {}) {
    const { onNotificationCreated, onConnectionError } = options;
    const onCreatedRef = useRef(onNotificationCreated);
    const onErrorRef = useRef(onConnectionError);
    onCreatedRef.current = onNotificationCreated;
    onErrorRef.current = onConnectionError;
    useEffect(() => {
        const url = getNotificationsHubUrl();
        const token = localStorage.getItem("accessToken");
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(url, {
            accessTokenFactory: () => token ?? "",
            withCredentials: false,
        })
            .withAutomaticReconnect()
            .build();
        connection.on(HUB_EVENT_NOTIFICATION_CREATED, (payload) => {
            if (onCreatedRef.current) {
                onCreatedRef.current(payload);
            }
        });
        let cancelled = false;
        connection.onclose((error) => {
            if (!error || cancelled || isStoppedDuringNegotiation(error))
                return;
            if (onErrorRef.current)
                onErrorRef.current(error);
        });
        connection.start().catch((err) => {
            if (cancelled || isStoppedDuringNegotiation(err))
                return;
            if (onErrorRef.current)
                onErrorRef.current(err);
        });
        return () => {
            cancelled = true;
            connection.stop().catch(() => { });
        };
    }, []);
}
